import { DISCLAIMERS } from '../config/disclaimers';
import styles from './DisclaimerFooter.module.css';

/**
 * The page-bottom disclaimer section: a numbered list of every methodology
 * footnote, in the fixed order defined by the shared `disclaimers` registry.
 * Charts point here via small superscript `DisclaimerMarker`s next to their
 * titles; each list item carries `id="disclaimer-<n>"` so those markers can
 * link straight to the relevant note.
 *
 * Rendered once, full-width, below the last card on the Analysis page. Static:
 * every footnote is always shown regardless of the current selection (the text
 * is written to be self-scoping), which keeps the numbering stable.
 */
const DisclaimerFooter = () => (
  <footer className={styles.footer} aria-label="Methodology disclaimers">
    <ol className={styles.list}>
      {DISCLAIMERS.map((disclaimer, index) => (
        <li key={disclaimer.id} id={`disclaimer-${index + 1}`} className={styles.item}>
          {disclaimer.text}
        </li>
      ))}
    </ol>
  </footer>
);

export default DisclaimerFooter;
